// ── Nacherfassung: search mask (filters, minimum criteria, pagination) ──────
(function () {
    'use strict';

    var form = document.getElementById('regcompl_search');
    if (!form) return;

    // Set window.regCompletionDebug = true in devtools for verbose logging.
    function dbg() {
        if (window.regCompletionDebug) console.log.apply(console, ['[regcompl-search]'].concat(Array.prototype.slice.call(arguments)));
    }

    // Null-safe helpers: a selector that matches nothing is silently skipped
    // (element sets differ per fair configuration).
    function checkedValue(sel) {
        var el = form.querySelector(sel);
        return el ? el.value : '';
    }
    function setChecked(sel, state) {
        var el = form.querySelector(sel);
        if (el) el.checked = state;
    }
    function setDisabled(sel, state) {
        form.querySelectorAll(sel).forEach(function (el) { el.disabled = state; });
    }
    function setLabelsDisabled(sel, state) {
        document.querySelectorAll(sel).forEach(function (el) {
            el.classList.toggle('is-label-disabled', state);
            // Unpatched templates render the disabled state as inline
            // style="color: lightgrey" — clear it when enabling, or the
            // label would stay grey forever.
            if (!state) el.style.removeProperty('color');
        });
    }
    function setHidden(sel, state) {
        var el = document.querySelector(sel);
        if (!el) return;
        el.hidden = state;
        // Unpatched templates hide via inline style="display:none", which
        // would win over hidden=false — clear it when revealing.
        if (!state) el.style.removeProperty('display');
    }

    // Suchfilter "Legitimierungsziel": deselecting every checkbox re-selects
    // all of them — an empty selection is not allowed.
    function checkLegiLevel() {
        if (!form.querySelector('input.legitimation_level:checked')) {
            form.querySelectorAll('input.legitimation_level').forEach(function (el) { el.checked = true; });
        }
    }

    // Reaction to a "Legitimierungsstatus" change.
    function checkLegiStatus() {
        var selectedStatus = checkedValue('input[name="regcomp_legi_status_list"]:checked');
        dbg('checkLegiStatus', selectedStatus);

        if (selectedStatus === '' || selectedStatus === 'none') {
            // Status "alle" / "kein Status": legi levels and the
            // all-years/all-fairs search scopes are not selectable.
            form.querySelectorAll('input.legitimation_level').forEach(function (el) {
                el.checked = false;
                el.disabled = true;
            });
            setLabelsDisabled('label.legi_level_list_label', true);

            // Legacy used the invalid selector "input.legitimation_level_hidden[0]";
            // meant is the first element of the set. Not rendered in every
            // configuration. TODO(Fachteam): is the fixed value "Presse"
            // correct across fairs, or should the server provide it?
            var levelHidden = document.querySelector('input.legitimation_level_hidden');
            if (levelHidden) levelHidden.value = 'Presse';

            setChecked('#regcompl_search_all_years', false);
            setDisabled('#regcompl_search_all_years', true);
            setLabelsDisabled('label[for="regcompl_search_all_years"]', true);

            setChecked('#regcompl_search_all_fairs', false);
            setDisabled('#regcompl_search_all_fairs', true);
            setLabelsDisabled('label[for="regcompl_search_all_fairs"]', true);

            // Keep one search-scope radio active in any case.
            setChecked('#regcompl_search_current_fair', true);
        } else {
            setDisabled('input.legitimation_level', false);
            checkLegiLevel();
            setLabelsDisabled('label.legi_level_list_label', false);

            setDisabled('#regcompl_search_all_years', false);
            setLabelsDisabled('label[for="regcompl_search_all_years"]', false);

            setDisabled('#regcompl_search_all_fairs', false);
            setLabelsDisabled('label[for="regcompl_search_all_fairs"]', false);
        }

        // Order-by choice is only meaningful for "interested"/"legitimated".
        if (selectedStatus === 'interested' || selectedStatus === 'legitimated') {
            setHidden('#legi-interested-order-by', false);
            setHidden('#lastchange_label_interested', selectedStatus !== 'interested');
            setHidden('#lastchange_label_legitimated', selectedStatus !== 'legitimated');
        } else {
            setHidden('#legi-interested-order-by', true);
        }
    }

    // Reaction to a search-scope change (current fair / all years / all
    // series of events). Value "2" (= #regcompl_search_all_fairs, third radio
    // of the same group, only rendered with vit_regi.search_in_all_fairs)
    // locks the status/order/level filters.
    function checkSearchAllYears() {
        var selectedType = checkedValue('input[name="regcompl_search_all_years"]:checked');
        dbg('checkSearchAllYears', selectedType);

        if (String(selectedType) === '2') {
            setDisabled('input.legitimation_status', true);
            setLabelsDisabled('label.legi_status_list_label', true);

            setDisabled('input.result_order_column', true);
            setLabelsDisabled('label.order_by_choice', true);

            setDisabled('input.legitimation_level', true);
            setLabelsDisabled('label.legi_level_list_label', true);
        } else {
            setDisabled('input.legitimation_status', false);
            setLabelsDisabled('label.legi_status_list_label', false);

            setDisabled('input.result_order_column', false);
            setLabelsDisabled('label.order_by_choice', false);

            checkLegiStatus();
        }
    }

    // Legacy-compat: unpatched templates still render inline
    // onchange="check_legi_status();" etc. Their jQuery-based declarations
    // (dead without jQuery) ran at parse time; running with `defer` we
    // overwrite them, so those inline handlers call the vanilla versions.
    window.check_legi_status = checkLegiStatus;
    window.check_legi_level = checkLegiLevel;
    window.check_search_all_years = checkSearchAllYears;

    // One delegated change listener replaces all inline onchange attributes;
    // radios/checkboxes added by other configurations join automatically.
    form.addEventListener('change', function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        if (t.matches('input.legitimation_status, input[name="regcomp_legi_status_list"]')) {
            checkLegiStatus();
        } else if (t.matches('input.legitimation_level')) {
            checkLegiLevel();
        } else if (t.matches('input[name="regcompl_search_all_years"], #regcompl_search_all_fairs')) {
            checkSearchAllYears();
        }
    });

    // ── Minimum search criteria (FMT-1967) ──────────────────────────────
    // Searching across all years/events needs a reg-id/ext-id or at least
    // data-min-search-len (default 3) characters across the text fields,
    // otherwise the query is too expensive for the database.
    function fieldValue(name) {
        var el = form.elements[name];
        return el && typeof el.value === 'string' ? el.value : '';
    }

    function checkMinimumSearchCriteria() {
        var allFairsEl = form.querySelector('#regcompl_search_all_fairs');
        var allYearsEl = form.querySelector('#regcompl_search_all_years');
        var inAllEvents     = !!(allFairsEl && allFairsEl.checked);
        var inAllFairEvents = !!(allYearsEl && allYearsEl.checked);
        if (!inAllEvents && !inAllFairEvents) return true; // current fair only: always allowed

        // ID search is an equals-search — one filled ID field suffices.
        var regId = fieldValue('regcompl_reg_id').replace(/\s/g, '');
        var extId = fieldValue('regcompl_ext_person_id').replace(/\s/g, '');
        if (regId.length > 0 || extId.length > 0) return true;

        var minLen = parseInt(form.getAttribute('data-min-search-len'), 10) || 3;
        var total = ['regcompl_name', 'regcompl_firstname', 'regcompl_email', 'regcompl_company',
                     'regcompl_street', 'regcompl_postcode', 'regcompl_city']
            .reduce(function (sum, name) { return sum + fieldValue(name).trim().length; }, 0);
        return total >= minLen;
    }

    form.addEventListener('submit', function (e) {
        var errorBox = document.getElementById('error_minimum_search_criteria');
        if (errorBox) {
            errorBox.hidden = true;
            errorBox.classList.remove('is-visible');
        }
        if (!checkMinimumSearchCriteria()) {
            dbg('submit blocked: minimum search criteria not met');
            if (errorBox) {
                errorBox.hidden = false;
                errorBox.style.removeProperty('display'); // unpatched templates render style="display:none"
                void errorBox.offsetWidth; // restart the opacity transition (fadeIn)
                errorBox.classList.add('is-visible');
            }
            e.preventDefault();
        }
    });

    // ── Pagination ───────────────────────────────────────────────────────
    function showNextPage(newPage) {
        var pageField = form.querySelector('input[name="regcompl_result_page"]');
        if (pageField) pageField.value = newPage;
        // requestSubmit (not submit) so the minimum-criteria check runs when
        // paging too; the search fields still hold the previous search input.
        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
        } else {
            form.submit();
        }
        return false;
    }
    // Keep the global alias: other fair templates may still render the
    // legacy inline onclick="return show_next_page(n)".
    window.show_next_page = showNextPage;

    function parsePage(raw, maxAttr) {
        var page = parseInt(raw, 10);
        if (isNaN(page) || page < 1) return null;
        var max = parseInt(maxAttr, 10);
        if (!isNaN(max) && page > max) page = max;
        return page;
    }

    // The pagination widget sits outside the form → document-level delegation.
    document.addEventListener('click', function (e) {
        if (!(e.target instanceof Element)) return;
        var link = e.target.closest('a[data-regcompl-page]');
        if (!link) return;
        e.preventDefault();
        var page = parsePage(link.getAttribute('data-regcompl-page'), null);
        if (page !== null) showNextPage(page);
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var field = e.target;
        if (!(field instanceof Element) || !field.matches('input.regcompl_pagination_field')) return;
        e.preventDefault();
        var page = parsePage(field.value, field.getAttribute('data-max-page'));
        if (page !== null) showNextPage(page);
    });

    // ── Initialisation ───────────────────────────────────────────────────
    // Sync all dependent controls to the currently selected filters.
    checkSearchAllYears();

    // Autofocus: the module marks the initially active field on the form
    // (find-by-id field when that form is shown, reg-id field otherwise).
    var focusEl = document.getElementById(form.getAttribute('data-initial-focus') || '') ||
                  document.getElementById('regcompl_find_by_id_val') ||
                  document.getElementById('regcompl_reg_id');
    if (focusEl) {
        focusEl.focus();
        focusEl.select();
    }
})();
